import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquipmentCardComponent } from './equipment-card.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [EquipmentCardComponent],
  exports: [EquipmentCardComponent],
  imports: [
    CommonModule,
    IonicModule,
    PipesModule
  ]
})
export class EquipmentCardModule { }
